import { render, staticRenderFns } from "./p4-assem.vue?vue&type=template&id=13403a00&scoped=true&lang=pug&"
import script from "./p4-assem.vue?vue&type=script&lang=js&"
export * from "./p4-assem.vue?vue&type=script&lang=js&"
import style0 from "./p4-assem.vue?vue&type=style&index=0&id=13403a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13403a00",
  null
  
)

export default component.exports